import React, {useState, useEffect} from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Loader from './Components/Loader';

const root = ReactDOM.createRoot(document.getElementById('root'));




root.render(
  <React.StrictMode>
   {
  <App /> 
   }
  </React.StrictMode>
);